var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.getSrc()
    ? _c(
        "div",
        {
          staticClass: "sc-message--text",
          style: Object.assign({}, _vm.messageColors, _vm.extendedStyle || {}),
          attrs: { id: "assetMessage" },
        },
        [
          _vm.isGroupMessage
            ? _c(
                "span",
                {
                  staticClass: "whatsapp-number-first",
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      _vm.showWhatsappChatStarterModal = true
                    },
                  },
                },
                [
                  _c(
                    "a",
                    {
                      style: { color: _vm.getWhatsappNumberColor() },
                      attrs: { href: "javascript:void(0)" },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.whatsappAuthorName) +
                          " - " +
                          _vm._s(_vm.whatsappAuthorNumber)
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "asset-card-gallery-wrap",
              on: {
                mouseenter: function ($event) {
                  _vm.assetGalleryHovered = true
                },
                mouseleave: function ($event) {
                  _vm.assetGalleryHovered = false
                },
              },
            },
            [
              _vm.isPreviewable
                ? _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "asset-card asset-card--previewable",
                      attrs: { content: _vm.$t("message.preview") },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleAssetClick.apply(null, arguments)
                        },
                      },
                    },
                    [
                      _c("div", { staticClass: "asset-card__thumb" }, [
                        _vm.getExt().toLowerCase() === "pdf"
                          ? _c(
                              "div",
                              { staticClass: "asset-card__thumb-scaler" },
                              [
                                _c("iframe", {
                                  staticClass: "asset-card__thumb-iframe",
                                  attrs: {
                                    src:
                                      _vm.getSrc() +
                                      "#toolbar=0&navpanes=0&scrollbar=0&page=1&view=FitH&zoom=page-width",
                                    scrolling: "no",
                                    frameborder: "0",
                                    tabindex: "-1",
                                  },
                                }),
                              ]
                            )
                          : _c(
                              "div",
                              { staticClass: "asset-card__thumb-placeholder" },
                              [
                                _vm.getExt()
                                  ? _c(
                                      "div",
                                      {
                                        staticClass: "fi fi-hero",
                                        class: "fi-" + _vm.getExt(),
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "fi-content" },
                                          [_vm._v(_vm._s(_vm.getExt()))]
                                        ),
                                      ]
                                    )
                                  : _c("a-icon", {
                                      staticStyle: {
                                        "font-size": "48px",
                                        opacity: "0.4",
                                      },
                                      attrs: { type: "file" },
                                    }),
                              ],
                              1
                            ),
                        _vm._v(" "),
                        _c("div", { staticClass: "asset-card__thumb-overlay" }),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "asset-card__footer" }, [
                        _c(
                          "div",
                          { staticClass: "asset-card__icon" },
                          [
                            _vm.getExt()
                              ? _c(
                                  "div",
                                  {
                                    staticClass: "fi",
                                    class: "fi-" + _vm.getExt(),
                                  },
                                  [
                                    _c("div", { staticClass: "fi-content" }, [
                                      _vm._v(_vm._s(_vm.getExt())),
                                    ]),
                                  ]
                                )
                              : _c("a-icon", {
                                  staticClass: "asset-card__fallback-icon",
                                  attrs: { type: "file" },
                                }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "asset-card__info" }, [
                          _c("p", { staticClass: "asset-card__name" }, [
                            _vm._v(_vm._s(_vm.getAssetName())),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "asset-card__ext" }, [
                            _vm._v(
                              _vm._s(
                                _vm.getExt() ? _vm.getExt().toUpperCase() : ""
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            staticClass:
                              "material-icons asset-card__preview-icon",
                          },
                          [_vm._v("open_in_new")]
                        ),
                      ]),
                    ]
                  )
                : _c(
                    "a",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "asset-card",
                      attrs: {
                        href: _vm.getSrc(),
                        download: "",
                        target: "_blank",
                        content: _vm.$t("message.download"),
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "asset-card__icon" },
                        [
                          _vm.getExt()
                            ? _c(
                                "div",
                                {
                                  staticClass: "fi",
                                  class: "fi-" + _vm.getExt(),
                                },
                                [
                                  _c("div", { staticClass: "fi-content" }, [
                                    _vm._v(_vm._s(_vm.getExt())),
                                  ]),
                                ]
                              )
                            : _c("a-icon", {
                                staticClass: "asset-card__fallback-icon",
                                attrs: { type: "file" },
                              }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "asset-card__info" },
                        [
                          _c("p", { staticClass: "asset-card__name" }, [
                            _vm._v(_vm._s(_vm.getAssetName())),
                          ]),
                          _vm._v(" "),
                          _vm.isFilterAsset
                            ? [
                                _c("p", { staticClass: "asset-card__meta" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.type")) +
                                      ": " +
                                      _vm._s(_vm.getExt())
                                  ),
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "asset-card__meta" }, [
                                  _vm._v(
                                    _vm._s(_vm.$t("message.sender")) +
                                      ": " +
                                      _vm._s(
                                        _vm.message.raw
                                          ? _vm.message.raw.user.name
                                          : ""
                                      )
                                  ),
                                ]),
                              ]
                            : _c("p", { staticClass: "asset-card__ext" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.getExt()
                                      ? _vm.getExt().toUpperCase()
                                      : ""
                                  )
                                ),
                              ]),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c("a-icon", {
                        staticClass: "asset-card__download-icon",
                        attrs: { type: "cloud-download" },
                      }),
                    ],
                    1
                  ),
              _vm._v(" "),
              _vm.assetGalleryHovered
                ? _c(
                    "button",
                    {
                      directives: [
                        {
                          name: "tippy",
                          rawName: "v-tippy",
                          value: {
                            followCursor: true,
                            placement: "bottom-end",
                          },
                          expression:
                            "{ followCursor: true, placement: 'bottom-end' }",
                        },
                      ],
                      staticClass: "asset-gallery-open-btn",
                      attrs: {
                        type: "button",
                        content: _vm.$t("chatbotv2.imageView"),
                      },
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          $event.preventDefault()
                          return _vm.$emit("open-gallery", _vm.message)
                        },
                      },
                    },
                    [
                      _c("span", { staticClass: "material-icons" }, [
                        _vm._v("collections"),
                      ]),
                    ]
                  )
                : _vm._e(),
            ]
          ),
          _vm._v(" "),
          _vm.showPreviewModal
            ? _c(
                "Modal2",
                {
                  attrs: {
                    title: _vm.getAssetName(),
                    showFooter: false,
                    xlarge: "",
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.showPreviewModal = false
                    },
                  },
                },
                [
                  _c("div", { staticClass: "asset-preview-modal" }, [
                    _c("div", { staticClass: "asset-preview-toolbar" }, [
                      _c("span", { staticClass: "asset-preview-filename" }, [
                        _vm.getExt()
                          ? _c("span", {
                              staticClass: "fi fi-sm",
                              class: "fi-" + _vm.getExt(),
                            })
                          : _vm._e(),
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.getAssetName()) +
                            "\n                "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "asset-preview-download-btn",
                          attrs: {
                            href: _vm.getSrc(),
                            download: "",
                            target: "_blank",
                          },
                        },
                        [
                          _c("span", { staticClass: "material-icons" }, [
                            _vm._v("download"),
                          ]),
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.$t("message.download")) +
                              "\n                "
                          ),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "asset-preview-frame-wrap" }, [
                      _c("iframe", {
                        staticClass: "asset-preview-frame",
                        attrs: {
                          src: _vm.getPreviewUrl(),
                          frameborder: "0",
                          allowfullscreen: "",
                        },
                      }),
                    ]),
                  ]),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.isGroupMessage
            ? _c(
                "div",
                {
                  staticStyle: {
                    display: "flex",
                    "flex-direction": "row",
                    "justify-content": "end",
                    "align-items": "center",
                    padding: "0 0.3rem",
                  },
                },
                [
                  _c(
                    "span",
                    {
                      staticClass: "sc-message-meta-new whatsapp-number",
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          _vm.showWhatsappChatStarterModal = true
                        },
                      },
                    },
                    [
                      _c(
                        "a",
                        {
                          style: { color: _vm.getWhatsappNumberColor() },
                          attrs: { href: "javascript:void(0)" },
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.whatsappAuthorName) +
                              " - " +
                              _vm._s(_vm.whatsappAuthorNumber)
                          ),
                        ]
                      ),
                    ]
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          !_vm.message.isMail && _vm.message.data.meta
            ? _c("span", { staticClass: "asset-message-meta" }, [
                _vm._v(_vm._s(_vm.message.data.meta)),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.actorInfo
            ? _c(
                "div",
                { staticClass: "actor-info-bar" },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("info_outline"),
                  ]),
                  _vm._v(" "),
                  !_vm.actorInfo.link
                    ? _c("span", [_vm._v(_vm._s(_vm.actorInfo.text))])
                    : _c(
                        "router-link",
                        {
                          staticClass: "actor-link",
                          attrs: { to: _vm.actorInfo.link },
                        },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.actorInfo.text) +
                              "\n            "
                          ),
                          _c(
                            "i",
                            {
                              staticClass: "material-icons",
                              staticStyle: { "font-size": "10px" },
                            },
                            [_vm._v("open_in_new")]
                          ),
                        ]
                      ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.showWhatsappChatStarterModal
            ? _c(
                "Modal2",
                {
                  attrs: {
                    title: _vm.$t("message.whatsappChatStart"),
                    showFooter: false,
                  },
                  on: {
                    cancel: function ($event) {
                      _vm.showWhatsappChatStarterModal = false
                    },
                  },
                },
                [
                  _c("WhatsappChatStarter", {
                    attrs: {
                      "default-phone-number": _vm.whatsappAuthorNumber,
                      "channel-override": "",
                      "phone-number-override": "",
                      "default-name": _vm.whatsappAuthorName,
                    },
                    on: {
                      close: function ($event) {
                        _vm.showWhatsappChatStarterModal = false
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }